import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Leaf } from "lucide-react";
import { adminLogin, formatApiError } from "../lib/api";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const res = await adminLogin(email, password);
      localStorage.setItem("ssw_admin_token", res.token);
      nav("/admin");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  const field = "w-full bg-cream border border-forest/15 rounded-xl py-3 px-4 text-forest focus:outline-none focus:border-terracotta";

  return (
    <div className="min-h-screen flex items-center justify-center px-6 bg-surface">
      <div className="w-full max-w-md bg-cream rounded-3xl p-10 shadow-[0_20px_60px_rgba(44,76,59,0.08)]">
        <div className="flex items-center gap-2 text-terracotta mb-2"><Leaf className="w-4 h-4" /><span className="text-xs uppercase tracking-[0.2em]">Admin</span></div>
        <h1 className="font-serif text-4xl text-forest mb-8">Studio login</h1>
        <form onSubmit={submit} className="space-y-5" data-testid="admin-login-form">
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" className={field} data-testid="admin-email" />
          <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password" className={field} data-testid="admin-password" />
          {error && <p className="text-sm text-terracotta" data-testid="admin-login-error">{error}</p>}
          <button type="submit" disabled={loading} data-testid="admin-login-submit" className="w-full rounded-full bg-forest hover:bg-terracotta text-cream py-3.5 text-sm uppercase tracking-widest font-semibold disabled:opacity-60" style={{ transition: "background-color 0.3s ease" }}>
            {loading ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
